import React, { useState } from "react";
import { useFormikContext } from "formik";
import AddItemModal from "./AddItemModal";
import AddIcon from "@mui/icons-material/Add";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import AppButton from "../../../../shared/AppButton";
import PreAuthItemsTable from "./PreAuthItemsTable";

function ItemsList({ formData, setFormData }) {
  const {
    values,
    errors,
    touched,
    setFieldValue,
  } = useFormikContext();
  const { t } = useTranslation();
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [currentItemIndex, setCurrentItemIndex] = useState(null);

  const deleteItem = (index) => {
    let tempFormData = [...values.items];
    tempFormData.splice(index, 1);
    setFieldValue("items", tempFormData);
  };

  const editItem = (index) => {
    setCurrentItemIndex(index);
    setShowAddItemModal(true);
  };

  return (
    <div className="personal-data !p-2 !mb-2">
      <div className="personal-title !mb-2 flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <div className="inventory-svg">
            <svg
              width="26"
              height="26"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
              <path
                d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                fill="#0070c2"
              ></path>
              <path
                d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                fill="#0070c2"
              ></path>
            </svg>
          </div>
          <div className="personal-head my-auto">
            <span>{t("Items*")}</span>
          </div>
        </div>
        <div>
          <AppButton
            label={t("Add Items")}
            startIcon={<AddIcon />}
            onClick={() => {
              if (
                values?.careTeamsArr?.length > 0 &&
                values?.diagnosisArr?.length > 0 &&
                values?.payerId &&
                values?.patientId
              ) {
                setShowAddItemModal(true);
              } else {
                toast.error("First fill above required fields");
              }
            }}
          />
        </div>
        <AddItemModal
          showAddItemModal={showAddItemModal}
          setShowAddItemModal={setShowAddItemModal}
          formData={formData}
          setFormData={setFormData}
          values={values}
          setMainFormFieldValue={setFieldValue}
          item={
            currentItemIndex !== null ? values.items[currentItemIndex] : null
          }
          currentItemIndex={currentItemIndex}
          setCurrentItemIndex={setCurrentItemIndex}
        />
      </div>

      <PreAuthItemsTable
        items={values.items || []}
        onEdit={editItem}
        onDelete={deleteItem}
      />

      {errors.items && touched.items ? (
        <p className="max-w-2xl mt-2 text-sm leading-6 text-red-500">
          {errors.items}
        </p>
      ) : null}
    </div>
  );
}

export default ItemsList;
